import dayjs from 'dayjs';

/** 1 second in milliseconds */

const SECOND = 1000;
/** 1 minute in milliseconds */

const MINUTE = SECOND * 60;
/** 1 hour in milliseconds */

const HOUR = MINUTE * 60;
/** 24 hours in milliseconds */

const DAY = HOUR * 24;
/** 7 days in milliseconds */

const WEEK = DAY * 7;
/** 1 non-leap year in milliseconds */

const YEAR = DAY * 365;
const initTimeZoneDate = (timeZone, timestamp) => Object.assign(Object.assign({}, timestamp && {
  timestamp
}), {
  timeZone: timeZone || dayjs.tz.guess()
});
const initDateInfo = () => ({
  dateInstruction: {
    timestamp: undefined,
    timeZone: dayjs.tz.guess()
  }
});
/**
 * Gets the current UTC ISO 8601 date time, with milliseconds stripped.
 *
 * Suitable for use as a Firebase db key (periods are disallowed in keys).
 *
 * Example: `2025-08-15T03:00:06Z`
 */

const getCurrentUtcIsoDateTime = () => {
  var _a;
  /** Example: `2025-08-15T03:00:06.945Z` */


  const withMs = new Date().toISOString();
  const withoutMs = (_a = withMs.split('.')[0]) !== null && _a !== void 0 ? _a : withMs;
  /** Example: `2025-08-15T03:00:06Z` */

  const withUtcIndicator = `${withoutMs}Z`;
  return withUtcIndicator;
};

export { DAY, HOUR, MINUTE, SECOND, WEEK, YEAR, getCurrentUtcIsoDateTime, initDateInfo, initTimeZoneDate };
